
const headers = [
    {
      label: 'เลขแจ้งเบาะแส',
      field: 'clueCode',
    },
    {
      label: 'ผู้ประกอบการ / ข้อมูลผู้แจ้ง',
      field: 'clueDetail',
    },
    {
      label: 'วันที่แจ้ง / ช่องทางแจ้งเบาะแส',
      field: 'clueStatus',
    },
    {
      label: 'หน่วยงานรับผิดชอบ',
      field: 'clueAgency',
    },
    // {
    //   label: 'Action',
    //   field: 'action',
    //   tdClass: 'text-center',
    // },
  ]

  export default headers